import styled from 'styled-components/macro';
import { Link } from 'react-router-dom';

import { colors, distances, border } from '../../styles/constants';

const Table = styled.div`
    margin: 0;
    padding: 0;
    width: 100%;
    display: table;
    table-layout: fixed;
    margin: 0;
    padding: 0;

    &.no-wrap > div > a > span,
    &.no-wrap > div > span > span {
        overflow: hidden;
        word-break: normal;
        text-overflow: ellipsis;
    }
`;

const Thead = styled.div`
    display: table-header-group;
    margin: 0;
    padding: 0;
`;

const Tbody = styled.div`
    display: table-row-group;
    margin: 0;
    padding: 0;
    border-left: ${distances.normal} solid blue;
`;

const Tr = styled.span`
    display: table-row;
    margin: 0;
    padding: 0;

    &:last-child > span:after {
        left: 0;
        right: 0;
    }
    &.interactive {
        cursor: pointer;
        &:hover > span {
            &:before {
                content: ' ';
                z-index: -1;
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                background: ${colors.interactiveBackgroundHover};
            }
        }

        .opacity-half-full-on-hover {
            opacity: 0;
        }
        &:hover {
            .opacity-half-full-on-hover {
                opacity: 1;
            }
        }
    }
    & > span.edge {
        max-width: ${distances.normal};
        width: ${distances.normal};
        padding: 0;
        margin: 0;
        &:after {
            display: none;
        }
    }
    &:last-child > span.edge {
        &:after {
            display: block;
        }
    }
`;

const LabelTr = styled.label`
     display: table-row;
     margin: 0;
     padding: 0;
     text-decoration: none;
     cursor: pointer;
     &:last-child > span:after {
         left: 0;
         right: 0;
     }
     &:hover > span {
         &:before {
             content: ' ';
             z-index: -1;
             position: absolute;
             top: 0;
             bottom: 0;
             left: 0;
             right: 0;
             background: ${colors.interactiveBackgroundHover};
         }
     }
     & > span.edge {
         max-width: ${distances.normal};
         width: ${distances.normal};
         padding: 0;
         margin: 0;
         &:after {
             display: none;
         }
     }
     &:last-child > span.edge {
         &:after {
             display: block;
         }
     }
 `;

const LinkTr = styled(Link)`
    display: table-row;
    margin: 0;
    padding: 0;
    text-decoration: none;

    &:last-child > span:after {
        left: 0;
        right: 0;
    }

    &:hover > span {
        &:before {
            content: ' ';
            z-index: -1;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            background: ${colors.interactiveBackgroundHover};
        }
    }
    .opacity-half-full-on-hover {
        opacity: 0.3;
    }
    &:hover {
        .opacity-half-full-on-hover {
            opacity: 1;
        }
    }
    & > span.edge {
        max-width: ${distances.normal};
        width: ${distances.normal};
        padding: 0;
        margin: 0;
        &:after {
            display: none;
        }
    }
    &:last-child > span.edge {
        &:after {
            display: block;
        }
    }
`;


const ExternalLinkTr = styled.a`
    display: table-row;
    margin: 0;
    padding: 0;
    text-decoration: none;

    &:last-child > span:after {
        left: 0;
        right: 0;
    }

    &:hover > span {
        &:before {
            content: ' ';
            z-index: -1;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            background: ${colors.interactiveBackgroundHover};
        }
    }
    .opacity-half-full-on-hover {
        opacity: 0.3;
    }
    &:hover {
        .opacity-half-full-on-hover {
            opacity: 1;
        }
    }
    & > span.edge {
        max-width: ${distances.normal};
        width: ${distances.normal};
        padding: 0;
        margin: 0;
        &:after {
            display: none;
        }
    }
    &:last-child > span.edge {
        &:after {
            display: block;
        }
    }
`;


const ClickTr = styled.span`
    display: table-row;
    margin: 0;
    padding: 0;
    text-decoration: none;
    cursor: pointer;

    &:last-child > span:after {
        left: 0;
        right: 0;
    }

    &:hover > span {
        &:before {
            content: ' ';
            z-index: -1;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            background: ${colors.interactiveBackgroundHover};
        }
    }
    & > span.edge {
        max-width: ${distances.normal};
        width: ${distances.normal};
        padding: 0;
        margin: 0;
        &:after {
            display: none;
        }
    }
    &:last-child > span.edge {
        &:after {
            display: block;
        }
    }
`;

const Th = styled.span`
    display: table-cell;
    margin: 0;
    padding: ${distances.small} 0;
    color: ${colors.textSecondary};
    font-size: 14px;
    font-weight: 400;
    border-bottom: ${border.normal} solid ${colors.borderLight};

    &.center {
        text-align: center;
    }

    &.first-child {
        padding-left: ${distances.normal};
    }

    &.last-child {
        padding-right: ${distances.normal};
    }

    &.collapse-1500 {
        @media (max-width: 1500px) {
            display: none;
        }
    }

    &.collapse-1200 {
        @media (max-width: 1200px) {
            display: none;
        }
    }

    &.collapse-768 {
        @media (max-width: 768px) {
            display: none;
        }
    }

    &.collapse-650 {
        @media (max-width: 650px) {
            display: none;
        }
    }
`;

const Td = styled.span`
    display: table-cell;
    margin: 0;
    padding: ${distances.small} 0;
    color: ${colors.text};
    font-size: 14px;
    font-weight: 400;
    position: relative;
    z-index: 0;
    font-feature-settings: 'tnum';

    &.align-right {
        text-align: right;
        padding-right: ${distances.small};
    }

    &:after {
        content: ' ';
        position: absolute;
        height: 1px;
        background: ${colors.borderLight};
        bottom: 0;
        left: 0;
        right: 0;
    }

    &.first-child {
        padding-left: ${distances.normal};
        &:after {
            left: ${distances.normal};
        }
    }

    &.last-child {
        padding-right: ${distances.normal};
        &:after {
            right: ${distances.normal};
        }
    }
    &.ellipsis {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        & > * > span {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 100%;
        }
    }

    &.center {
        text-align: center;
    }

    &.collapse-1500 {
        @media (max-width: 1500px) {
            display: none;
        }
    }

    &.collapse-1200 {
        @media (max-width: 1200px) {
            display: none;
        }
    }

    &.collapse-768 {
        @media (max-width: 768px) {
            display: none;
        }
    }

    &.collapse-650 {
        @media (max-width: 650px) {
            display: none;
        }
    }

    @media (max-width: 1600px) {
        &.first-child {
            padding-left: ${distances.tiny};
            &:after {
                left: ${distances.tiny};
            }
        }

        &.last-child {
            padding-right: ${distances.tiny};
            &:after {
                right: ${distances.tiny};
            }
        }

        &.align-right {
            text-align: right;
            padding-right: ${distances.tiny};
        }
    }
`;

export { Table, Thead, Tbody, Tr, LinkTr, ExternalLinkTr, ClickTr, LabelTr, Th, Td };
